
import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Artists from './components/Artists';
import Testimonials from './components/Testimonials';
import Studio from './components/Studio';
import PastEvents from './components/PastEvents';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Artists />
      <PastEvents />
      <Testimonials />
      <Studio />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
